/* OKKO B2B — "Avvisami" quando torna disponibile (back in stock via Klaviyo).
 *
 * Il bottone vive nella colonna quantita' delle righe ESAURITE
 * (okko-qty-input.liquid) al posto del trattino. Il rivenditore e' sempre
 * loggato, quindi niente form: un click iscrive email+variante all'API client
 * di Klaviyo (l'avviso vero lo manda il flusso "Subscribed to Back in Stock").
 *
 * NESSUNO stato persistente (scelta di Nicolas, 2026-08-06): l'API client non
 * e' interrogabile, quindi qualunque memoria locale finisce per mentire (resta
 * "iscritto" anche dopo che l'avviso e' partito e l'iscrizione e' consumata).
 * Come il widget nativo Klaviyo: il bottone e' sempre cliccabile, la deduplica
 * la fa il server. La spunta "fatto" vive solo nella pagina corrente.
 *
 * Il company id si legge dallo script klaviyo.js che l'app embed inietta:
 * se l'embed e' spento l'iscrizione non puo' funzionare, e il bottone lo dice.
 */
(() => {
  // memoria della SOLA pagina corrente, chiave email:variante
  const fatti = {};
  // la vecchia memoria persistente, da ripulire dai browser che ce l'hanno
  try { localStorage.removeItem('okko-bis'); } catch (e) { /* storage negato */ }

  function companyId() {
    const s = document.querySelector('script[src*="klaviyo.js?company_id="]');
    const m = s && s.src.match(/company_id=([A-Za-z0-9]+)/);
    return m ? m[1] : '';
  }

  const chiave = (btn) => `${btn.dataset.okkoBisMail}:${btn.dataset.okkoBis}`;

  function setFatto(btn) {
    const T = (window.OKKO && window.OKKO.testi) || {};
    btn.classList.add('is-fatto'); // il cambio icona lo fa il CSS su questa classe
    // NIENTE disabled: un bottone disabled non emette eventi mouse e il
    // tooltip condiviso (delega su mouseover) non comparirebbe. Il click lo
    // ferma la guardia sulla classe; per le AT c'e' aria-disabled.
    btn.disabled = false;
    btn.setAttribute('aria-disabled', 'true');
    const testo = btn.querySelector('[data-okko-bis-testo]');
    if (testo) testo.textContent = ''; // resta la spunta, parla il tooltip
    const tipFatto = T.bisFatto || 'Ti avviseremo';
    btn.dataset.okkoTip = tipFatto;
    btn.setAttribute('aria-label', tipFatto);
  }

  /** Riallinea i bottoni RI-renderizzati in pagina (swap AJAX dei filtri, righe
      delle modali costruite in JS): un click appena fatto non deve ricomparire
      attivo un attimo dopo. A una ricarica invece si riparte puliti, di proposito. */
  function paint() {
    document.querySelectorAll('[data-okko-bis]').forEach((btn) => {
      if (fatti[chiave(btn)]) setFatto(btn);
    });
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-okko-bis]');
    if (!btn || btn.disabled || btn.classList.contains('is-fatto')) return;
    const T = (window.OKKO && window.OKKO.testi) || {};
    const cid = companyId();
    const testo = btn.querySelector('[data-okko-bis-testo]');
    if (!cid) {
      if (testo) testo.textContent = T.bisErrore || 'Non ha funzionato, riprova';
      return;
    }
    btn.disabled = true; // anti doppio click; riabilitato solo in errore
    try {
      const r = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${cid}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2025-07-15' },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email: btn.dataset.okkoBisMail } } },
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${btn.dataset.okkoBis}` } },
            },
          },
        }),
      });
      if (!r.ok) throw new Error(String(r.status));
      fatti[chiave(btn)] = true;
      setFatto(btn);
    } catch (err) {
      btn.disabled = false;
      if (testo) testo.textContent = T.bisErrore || 'Non ha funzionato, riprova';
    }
  });

  /** Markup del bottone per i contesti costruiti in JS (lista varianti PDP,
      modale Salvati): clona il <template data-okko-bis-tpl> di theme.liquid e
      aggancia l'id variante. '' se la funzione e' spenta (niente template). */
  function bottoneHtml(variantId) {
    const tpl = document.querySelector('template[data-okko-bis-tpl]');
    const btn = tpl && tpl.content.firstElementChild && tpl.content.firstElementChild.cloneNode(true);
    if (!btn) return '';
    btn.setAttribute('data-okko-bis', String(variantId));
    return btn.outerHTML; // lo stato "gia' chiesto" lo applica paint() dopo l'inserimento
  }

  window.OKKO = window.OKKO || {};
  window.OKKO.paintBis = paint;
  window.OKKO.bisBottone = bottoneHtml;
})();
